import { ChainId, Config, env } from '../constansts';

export function getConfig(chainId?: ChainId): Partial<Config> {
  return chainId ? env.config[chainId] ?? {} : {};
}
